// src/hooks/useMailer.js
import { useState } from 'react';

export function useMailer(endpoint = 'contact') {
  const [loading,   setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error,     setError]     = useState('');

  const send = async (data) => {
    setLoading(true);
    setError('');
    try {
      const enrichedData = {
        ...data,
        pagina_origen: window.location.href,
        referrer: document.referrer || 'directo',
      };
      const res  = await fetch(`https://culturlingua.com/${endpoint}.php`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(enrichedData),
      });
      const json = await res.json();
      if (json.success) {
        setSubmitted(true);
      } else {
        setError(json.error || 'Hubo un problema. Intenta de nuevo.');
      }
    } catch {
      setError('No se pudo conectar. Escríbenos a administracion@culturlingua.com');
    } finally {
      setLoading(false);
    }
  };

  const ErrorBox = error ? (
    <div style={{
      background: '#fef2f2', border: '1px solid #fecaca',
      borderRadius: '10px', padding: '12px 16px',
      marginBottom: '16px', color: '#dc2626', fontSize: '0.9rem'
    }}>
      {error}
    </div>
  ) : null;

  return { send, loading, submitted, error, ErrorBox };
}